import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React, { useLayoutEffect } from "react"
import GlobalHelper from "../common/GlobalHelper.jsx"
import LoadingSpinner from "../common/spinner/loading.component.jsx"
import IntegrationConfigurationService from "../state/integration/IntegrationConfigurationService"
import LoadingComponent from "./loading.component.jsx"

const queryString = require("query-string")

type OwnProps = {
    children: JSX.Element,
    initialLoading: boolean,
    loading: boolean,
    loadInitialSubscription: () => void,
    setIsValid: (valid: boolean) => void
    changeLoading: (updated: boolean) => void,
    isTrial: boolean,
}

const betterReplace = (url: string, search: string, replace: string, from: number) => {
    if (url.length > from) {
        const regex = new RegExp(search, "g")
        return url.slice(from).replace(regex, replace)
    }
    return url
}

const getValue=(elem)=>{
    if (elem && !Array.isArray(elem)) {
        return elem
    }
    if (elem && Array.isArray(elem) && elem.length > 0) {
        return elem[0]
    }
    return ""
}

const ValidateSubscription = (props: OwnProps) => {
    const uri = queryString.parse(betterReplace(location.search, "\\?", "&", 1))

    const validateExternalAccount = async (integrationKey) => {
        let body = { "verificationToken": "" }
        
        const subscriptionId = getValue(uri.subscription_id)
        const errorCode = getValue(uri.error_code)
        const errorMessage = getValue(uri.error_message)
        
        const hasError =  errorCode && errorCode != "500010"

        if (errorCode && errorCode == "500010" && GlobalHelper.hasVendIntegration()) {
            window.location.replace(AppContext.getOptions().webCpqUrl + "/my-account")
        }

        const verifyVendExternalSubscription = GlobalHelper.hasVendIntegration() && uri &&
            ((subscriptionId && (!errorCode || errorCode == "500010")) || hasError)
        if (verifyVendExternalSubscription) {
            body = { "verificationToken": subscriptionId }
        }

        if (verifyVendExternalSubscription || GlobalHelper.hasShopifyIntegration()) {
            body["isTrial"] = props.isTrial
            if (verifyVendExternalSubscription && errorCode) {
                body["error"] = errorMessage
                body["errorCode"] = errorCode
            }
            const res = await IntegrationConfigurationService.validateExternalSubscription(integrationKey, body)
            if (res.error && !res.updatedChargebee) {
                props.setIsValid(false)
            } else {
                props.changeLoading(res.updatedChargebee ?? false)
            }
        }

        props.loadInitialSubscription()

    }

    useLayoutEffect(() => {
        const accountIntegrationKey = AppContext.getAccount().attributes.integrationKey
        if (GlobalHelper.integrationSupportsExternalSubscription(accountIntegrationKey)) {
            validateExternalAccount(accountIntegrationKey)
        } else {
            props.loadInitialSubscription()
        }
    }, [])

    return props.loading ?
        <div>
            <LoadingComponent
                onFinishLoading={props.changeLoading}
            />
        </div>
        : props.initialLoading ? <LoadingSpinner /> : props.children

}

export default ValidateSubscription


// WEBPACK FOOTER //
// ./src/my-account/validatesubscription.tsx